import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { FileManagerComponent } from '@shared/components/file-manager/file-manager.component';
import { FileViewerComponent } from '@shared/components/file-viewer/file-viewer.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';
import { FileMetadata } from '@shared/services/api.service';

export interface FileManagerDialogInput {
  header?: string;
  metadata?: FileMetadata;
  metadataFn?: () => FileMetadata;
  path?: string;
  pathFn?: () => string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FileManagerComponent, FileViewerComponent],
  selector: 'aux-file-manager-dialog',
  styles: [],
  template: `
    <div class="w-screen max-w-[240px]"></div>
    <aux-file-manager
      class="h-32"
      #manager
      [fetchFilesOnInit]="false"
      [pathFn]="pathFn"
      [eager]="true"
      [path]="path"
      [metadataFn]="metadataFn"
      [metadata]="metadata"
      [insertDocument]="true"
      [showSuccessOnUpload]="true"
    />
    <div class="mt-4 max-h-60 overflow-auto">
      <aux-file-viewer [fileManager]="manager" [disableFirstFileMargin]="true" />
    </div>
  `,
})
export class FileManagerDialogComponent {
  ref = inject<CustomOverlayRef<unknown, FileManagerDialogInput>>(CustomOverlayRef);

  metadata: FileMetadata = {};
  metadataFn: (() => FileMetadata) | undefined;
  path = '';
  pathFn: (() => string) | undefined;

  constructor() {
    if (this.ref.data) {
      this.pathFn = this.ref.data.pathFn;
      this.path = this.ref.data.path || '';
      this.metadataFn = this.ref.data.metadataFn;
      this.metadata = this.ref.data.metadata || {};
    }
  }
}
